import { Button, Group } from "@mantine/core";
import { useCallback, type FC } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigateTileset } from "../hooks/navigate";
import type { AccountInfo } from "../../../../types/account";
import type { Tileset, TilesetDataset, TilesetVersion } from "../types/tileset";
import { TilesetMenu } from "../../components/TilesetMenu.js";

export interface TilesetItemControlsProps {
  account: AccountInfo;
  tileset: Tileset;
  dataset: TilesetDataset;
  version: TilesetVersion | null;
}

export const TilesetItemControls: FC<TilesetItemControlsProps> = (props) => {
  const { account, tileset, dataset } = props;
  const navigate = useNavigateTileset();

  const handleViewTileset = useCallback(() => {
    navigate(
      account.name,
      tileset.key,
      dataset?.key,
    );
  }, [account, tileset, dataset]);

  return (
    <Group gap="xs">
      <Button h={32} onClick={handleViewTileset} variant="primary">
        <FormattedMessage defaultMessage="View" id="button.view" />
      </Button>
      <TilesetMenu
        {...props}
        width={200}
        position="bottom-end"
      />
    </Group>
  );
};
